// extracted by mini-css-extract-plugin
export default {"mariage":"mariage_mariage__a0x4O"};